/**
 * usePlanInfo — single source of truth for plan display info.
 *
 * Change `PLAN_NAME` or `ACCOUNT_USAGE_URL` here to update all references
 * across the app at once.
 */

const PLAN_NAME = 'Free';
const ACCOUNT_USAGE_URL = '/app/account#plan-usage';

export interface PlanInfo {
    /** Display name of the current plan, e.g. "Free". */
    planName: string;
    /** URL of the Plan & Usage section on the account page. */
    accountUsageUrl: string;
    limits: {
        /** Maximum number of versions kept per note. */
        maxVersionsPerNote: number;
        /** Maximum single note size in bytes (1 MB). */
        maxNoteSizeBytes: number;
        /** Maximum total text storage in bytes (10 MB). */
        maxTextStorageBytes: number;
    };
}

export function usePlanInfo(): PlanInfo {
    return {
        planName:         PLAN_NAME,
        accountUsageUrl:  ACCOUNT_USAGE_URL,
        limits: {
            maxVersionsPerNote:  10,
            maxNoteSizeBytes:    1  * 1024 * 1024,
            maxTextStorageBytes: 10 * 1024 * 1024,
        },
    };
}

